import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Dropzone             from 'react-dropzone';
import FaUpload             from 'react-icons/lib/fa/upload';
import FaCamera             from 'react-icons/lib/fa/camera';
import FaCheck              from 'react-icons/lib/fa/check';
import FaSpinner            from 'react-icons/lib/fa/spinner';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let HttpService = require('../Managers/HttpService.js');
const pretty = require('prettysize');
const uuidV1 = require('uuid/v1');

class UploadInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            isValid: true,
            files: [],
        };
    }

    componentWillMount() {
        this.setState({isValid: true});
        this.props.isValid(true);
        // we load all the files out for this component, and make sure
        // we render them out
        let files = Quote.getByPath(this.props.source + '.files');
        if (files) {
            this.setState({ files });
        }
    }

    onDrop(acceptedFiles) {
        let applicationId = window.localStorage.getItem('applicationId');
        let anyOver10 = false;

        // rip out files larger than 10 meg, and if any ARE
        // over 10 meg, trip the error
        acceptedFiles = acceptedFiles.filter(f => {
            let megabyteValue = ((f.size / 1024) / 1024);
            if (megabyteValue <= 10) {
                return true;
            } else {
                anyOver10 = true;
                return false;
            }
        });

        // if any files tripped the error, flag it. otherwise, turn errors off
        if (anyOver10) {
            this.setState({
                isValid: false,
                hasError: true,
                errors: ["Please upload files smaller than 10Mb"],
            });
        } else {
            this.setState({
                isValid: true,
                hasError: false,
                errors: [],
            });
        }

        // grab any we already previously uploaded from state
        let files = this.state.files;

        // update our state to show files that have been uploaded
        files = files.concat(acceptedFiles.map(f => {
            return {
                key: uuidV1(),
                name: f.name,
                applicationId,
                contextInfo: this.props.contextInfo,
                size: pretty(f.size),
                isUploaded: false,
            };
        }));

        // resave all the files to local storage
        Quote.setByPath(this.props.source + '.files', files);

        // update our state..
        this.setState({
            files
        });

        // do the upload
        files.map((fileInstance, i) => {
            if (!fileInstance.isUploaded) {
                // find the acceptedFiles instance of the correct thing from our files
                let file = acceptedFiles.find((acceptedFileInstance) => {
                    return acceptedFileInstance.name == fileInstance.name;
                });
                HttpService.postUploadDocument(applicationId, file, this.props.contextInfo)
                .then(res => {
                    let files = this.state.files;
                    files[i].isUploaded = true;
                    files[i].nodeId = res.text;
                    this.setState({
                        files
                    });
                    // resave again once uploading has completed
                    Quote.setByPath(this.props.source + '.files', files);
                })
                .catch(() => {
                    // the document upload failed - delete the file from
                    // the state or something?
                    let files = this.state.files;
                    files.splice(i, 1);
                    this.setState({
                        files
                    });
                    // resave again once uploading has completed
                    Quote.setByPath(this.props.source + '.files', files);
                });
            }
        });
    }

    /**
     * delete a file from the blob storage, the global file list,
     * base individual application and the local storage
     */
    // deleteFile(file) {
    //     // strip out the file we're deleting from the state files array
    //     let files = this.state.files.filter((f) => {
    //         return (f.nodeId != file.nodeId);
    //     });
    //
    //     // delete the file via the endpoint...
    //     HttpService.postDetachDocument(nodeId)
    //     .then(() => {
    //         // ...and then remove the file from state, and reset the local storage data
    //         this.setState({
    //             files
    //         });
    //         Quote.setByPath(this.props.source + '.files', files);
    //     });
    // }

    buildStateKeyForFile(name) {
        return this.props.source + '.files.' + name.replace(/\./g, "-");
    }

    buildBlobKeyForFile(name) {
        return name + '_blob';
    }

    render() {
        let numberofColumns = 1;
        if (this.props.fileUpload === true && this.props.cameraUpload === true) {
            numberofColumns = 2;
        }

        return(
            <div className="question-input">
                <div className={'row-constrained row-' + numberofColumns}>
                {this.props.fileUpload === true ?
                    <div className="column">
                        <Dropzone onDrop={this.onDrop.bind(this)} className="uploader">
                            <div className="question-top">
                                Upload existing evidence by clicking, tapping, or dragging files here. Max file size is 10Mb.
                            </div>
                            <div className="question-input">
                                <FaUpload />
                            </div>
                        </Dropzone>
                    </div>
                : null}

                {this.props.cameraUpload ?
                    <div className="column hidden-md-up">
                        <Dropzone onDrop={this.onDrop.bind(this)} className="uploader">
                            <div className="question-top">
                                Take and upload a photo of your evidence by tapping the icon below
                            </div>
                            <div className="question-input">
                                <FaCamera />
                            </div>
                        </Dropzone>
                    </div>
                : null}
                {this.state.files.length >= 1 ?
                    <div>
                        <p>Uploaded files</p>
                        <ul>
                            {
                                this.state.files.map(file => {
                                    let icon = (file.isUploaded) ? <FaCheck /> : <FaSpinner className="spin" />;
                                    return (
                                        <li key={file.key}>
                                            {file.name} ({file.size}) {icon}
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                : null }
                </div>
                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

UploadInput.propTypes = {
    fieldName:      PropTypes.string.isRequired,
    storageKey:     PropTypes.string,
    fileUpload:     PropTypes.bool.isRequired,
    cameraUpload:   PropTypes.bool.isRequired,
    contextInfo:    PropTypes.string,
    source:         PropTypes.string,
    isValid:        PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func,
    ]),
};

UploadInput.defaultProps = {
    fileUpload: true,
    cameraUpload: true,
};

export default UploadInput;


// WEBPACK FOOTER //
// ./src/components/Fields/UploadInput.js